module.exports = __webpack_public_path__ + "img/avatar.709d5d9c.png";